const adSvg = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const menuFooter = document.querySelectorAll('.menu__footer .menu-item a')
		menuFooter.forEach(function(item){
		const hrefAd = item.getAttribute("href");
		
        if(hrefAd.indexOf("https://atelierdesign.be") !== -1) {
			const svgAd = '<svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5997 0.000488281H12.2465V2.99662H15.328C16.5583 2.99662 17.7381 3.47078 18.6081 4.31482C19.478 5.15885 19.9668 6.30362 19.9668 7.49727C19.9668 8.69092 19.478 9.83569 18.6081 10.6797C17.7381 11.5238 16.5583 11.9979 15.328 11.9979H14.1152L9.62887 0.0133206H5.65274L0 15.0005H3.41949L4.48641 11.9979H10.6096L11.6898 15.0005H15.5931C17.5853 14.9204 19.4684 14.0962 20.8489 12.7002C22.2293 11.3043 23 9.44467 23 7.51014C23 5.57561 22.2293 3.71595 20.8489 2.32C19.4684 0.924045 17.5853 0.0998593 15.5931 0.0197564L15.5997 0.000488281ZM5.55996 9.00179L7.54802 3.44026L9.53608 9.00179H5.55996Z" fill="#12225C"/></svg>'
			const creaSpan = document.createElement('span')
			creaSpan.classList.add('svg-ad')
			item.setAttribute('target', '_blank')
			creaSpan.innerHTML = svgAd
			item.appendChild(creaSpan)
        }
	})
	})
}
export default adSvg